<template>
	<section class="ctn">
		<header class="header left">
			<router-link class="paper-action" :to="{ path: `/projects`}"><heim-icon icon="arrow-back"></heim-icon><span>{{ $t('back') }}</span></router-link>
			<router-link class="paper-action" :to="{ path: `/projects/${project.id}/edit`}"><span>{{ $t('edit') }}</span><heim-icon icon="chevron-right"></heim-icon></router-link>
		</header>
		<main class="project-details">
			<section class="info">
				<heim-card>
					<main>
						<div class="row">
							<h1>{{ $t('project') }}</h1>
							<span></span>
						</div>
					</main>
				</heim-card>
				<heim-card class="monitoring">
					<main>
						<div class="row">
							<div class="details-row">
								<span>{{ $t('customer') }}</span>
								<span class="badge">{{ project.name }}</span>
							</div>
						</div>
						<div class="row">
							<div class="details-row">
								<span>{{ $t('title') }}</span>
								<span class="badge" v-if="project.title">{{ project.title }}</span>
								<span class="badge" v-else>{{ $t('na') }}</span>
							</div>
						</div>
            <div class="row">
							<div class="details-row">
								<span>{{ $t('creationDate') }}</span>
								<span class="badge" v-if="project.date">{{ $d(new Date(project.date), 'short') }}</span>
								<span class="badge" v-else>{{ $t('na') }}</span>
							</div>
						</div>
						<div class="row">
							<div class="details-row">
								<span>{{ $t('techno') }}</span>
								<span class="badge" v-if="project.SiteTypes">
									<router-link :to="{ path: `/types/${ project.SiteTypes.id}/details` }">{{ project.SiteTypes.type }}</router-link>
								</span>
								<span class="badge" v-else>{{ $t('na') }}</span>
							</div>
						</div>
						<div class="row">
							<div class="details-row">
								<span>{{ $t('manager') }}</span>
								<span class="badge" v-if="project.Users">
									<router-link :to="{ path: `/users/${ project.Users.id}/details` }">{{ project.Users.name }}</router-link></span>
								<span class="badge" v-else>{{ $t('na') }}</span>
							</div>
						</div>
						<div class="row">
							<div class="details-row">
								<span>{{ $t('status') }}</span>
								<span class="badge" v-if="project.Status">{{ $t(project.Status.name) }}</span>
								<span class="badge" v-else>{{ $t('na') }}</span>
							</div>
						</div>
						<div class="row">
							<div class="details-row">
								<span>{{ $t('benefits') }}</span>
								<span class="badge" v-if="project.Benefits">{{ $t(project.Benefits.name) }}</span>
								<span class="badge" v-else>{{ $t('na') }}</span>
							</div>
						</div>						
            <div class="row">
							<div class="details-row">
								<span>{{ $t('projectMantis') }}</span>
								<span class="badge" v-if="project.mantis_id">
									<a :href="'https://mantis.activbrowser.com/set_project.php?project_id=' + project.mantis_id" target="_blank">
										Mantis {{ project.mantis_id }} <heim-icon icon="open-in-new"></heim-icon>
									</a>
								</span>
								<span class="badge" v-else>{{ $t('na') }}</span>
							</div>
						</div>
						<header><h2>{{ $t('description') }}</h2></header>
						<div class="row">
							<p>{{ project.description }}</p>
						</div>
					</main>
				</heim-card>
			</section>
			<section class="info">
				<heim-card>
					<main>
						<div class="row">
							<h1>{{ $t('project') }}</h1>
							<span></span>
						</div>
					</main>
				</heim-card>
				<heim-card class="monitoring">
					<main>
						<div class="row">
							<div class="details-row">
								<span>{{ $t('quoteNumber') }}</span>
								<span class="badge">{{ project.quote ? project.quote : $t('na') }}</span>
							</div>
						</div>
						<div class="row">
							<div class="details-row">
								<span>{{ $t('amountTotal') }}</span>
								<span class="badge">{{ project.amount ? $n(project.amount, "currency") : $t('na') }}</span>
							</div>
						</div>
						<div class="row">
							<div class="details-row">
								<span>{{ $t('numberDay') }}</span>
								<span class="badge">{{ project.days && project.days !== 0 ? project.days : $t('na') }}</span>
							</div>
						</div>
						<div class="row">
							<div class="details-row">
								<span>{{ $t('adr') }}</span>
								<span class="badge">{{ (project.amount && project.days !== 0 && project.days) ? $n((project.amount / project.days), "currency") + ' ' +  $t('byDay') : $t('na') }} </span>
							</div>
						</div>
						<div class="row">
							<div class="details-row">
								<span>{{ $t('forecastedWorkload') }}</span>
								<span class="badge">{{ project.forecasted_workload ? $n(project.forecasted_workload, "currency") : $t('na') }}</span>
							</div>
						</div>
						<div class="row">
							<div class="details-row">
								<span>{{ $t('grossProfit') }}</span>
								<span class="badge">{{ (project.amount || project.forecasted_workload) ? $n(project.amount - project.forecasted_workload, "currency") : $t('na') }}</span>
							</div>
						</div>
						<header><h2>{{ $t('comment') }}</h2></header>
						<div class="row">
							<p>{{ project.comment ? project.comment : $t('na')}}</p>
						</div>
					</main>
				</heim-card>
				<heim-card class="endpoints">
          <header>
            <h1>{{ $t('invoiceNumber') }}</h1>
          </header>
          <main>
            <div class="row" v-for="(project, idx) in project.Invoices" :key="`endpoint-${idx}`">
              <div class="details-row">
                <span>{{ project.number }}</span>
                <span class="badge">{{ $n(project.amount, "currency") }}</span>
              </div>
            </div>
          </main>
        </heim-card>
			</section>
		</main>
	</section>
</template>


<script>
import HeimIcon from "@/components/icon/heim-icon";
import HeimCard from "@/components/layout/card/heim-card.vue";
import { mapState } from "vuex";
import { dateFilter } from "vue-date-fns";

export default {
  name: "ProjectsDetails",
  components: {
    HeimIcon,
    HeimCard
  },
  data() {
    return {
      options: {
        responsive: true,
        scales: {
          xAxes: [
            {
              type: "time",
              time: {
                // round: 'day'
                tooltipFormat: "ll HH:mm"
              },
              scaleLabel: {
                display: true,
                labelString: "Time"
              }
            }
          ],
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: "value"
              }
            }
          ]
        }
      }
    };
  },
  mounted() {
    const id = this.$route.params.id;
    this.$store.dispatch("getProject", id);

    this.$watch(
      vm => vm.project,
      val => {
        this.$store.dispatch("setTitle", `Project - ${val.name}`);
      }
    );
  },
  computed: {
    ...mapState({
      project: state => state.projectsState.project
    })
  },
  methods : {
    getTotal(items) {
      const cost = [];
      items.map(item => {
        cost.push(item.amount);
      });

      return cost.reduce((a, b) => a + b, 0);
    }
  },
  filters: {
    date: dateFilter
  }
};
</script>

<style scoped>
.project-details,
.details-row {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap-reverse;
}
.details-row {
  width: 100%;
}

.details-row .badge {
  background-color: var(--heim-grey-color);
}

.project-details > .paper-card,
.project-details > .info {
  width: 100%;
  margin-right: 0;
}

.project-details .stats,
.project-details .monitoring {
  margin-bottom: 1em;
}

.info {
  display: flex;
  flex-direction: column;
}

.disabled {
  color: #8b969c;
}

.monitoring,
.site {
  margin-bottom: 1em;
}

.link {
  padding: 1em;
  border-bottom: 1px solid #eee;
}

.link:last-child {
  border: none;
}

.info .paper-card {
  border-radius: 3px 3px 0 0;
}

.paper-card.monitoring {
  border-radius: 0;
}
.details-row span:first-child {
  padding: 0.2rem 0;
}

/* Wide layout: when the viewport width is bigger than 460px, layout
changes to a wide layout. */
@media (min-width: 460px) {
  .project-details {
    flex-wrap: nowrap;
  }
  .project-details > .paper-card,
  .project-details > .info {
    width: 50%;
    margin-right: 1em;
    height: 100%;
  }
}
</style>
